document.addEventListener('DOMContentLoaded', function() {
    var dropdownButton = document.querySelector('.custom-dropdown__button');
    var dropdownMenu = document.querySelector('.custom-dropdown__menu');
    var currentProductHandle = window.location.pathname.split('/').pop(); // Assumes the product handle is the last segment in the URL path
    
    dropdownButton.addEventListener('click', function() {
      var isExpanded = dropdownButton.getAttribute('aria-expanded') === 'true';
      dropdownButton.setAttribute('aria-expanded', !isExpanded);
      dropdownMenu.setAttribute('aria-hidden', isExpanded);
      dropdownMenu.style.display = isExpanded ? 'none' : 'block';
    });
  
    document.addEventListener('click', function(event) {
      if (!dropdownButton.contains(event.target) && !dropdownMenu.contains(event.target)) {
        dropdownButton.setAttribute('aria-expanded', 'false');
        dropdownMenu.setAttribute('aria-hidden', 'true');
        dropdownMenu.style.display = 'none';
      }
    });
  
    // Mark the current product as selected in the dropdown
    document.querySelectorAll('.custom-dropdown__link').forEach(function(link) {
      var linkProductHandle = link.getAttribute('href').split('/').pop();
      if (linkProductHandle === currentProductHandle) {
        link.closest('.custom-dropdown__item').classList.add('custom-dropdown__item--selected');
      }
    });
  });
  